import React, { FC, useEffect } from 'react';

type Props = {
  wistiaScriptMediasUrl: string;
  wistiaScriptAssetsUrl: string;
  wistiaVideoDiv: string;
  videoClassName?: string;
};

export const EmbeddedVideo: FC<Props> = ({
  wistiaScriptMediasUrl,
  wistiaScriptAssetsUrl,
  wistiaVideoDiv,
  videoClassName,
}) => {
  useEffect(() => {
    const wistiaScriptMedias = document.createElement('script');
    wistiaScriptMedias.src = wistiaScriptMediasUrl;
    wistiaScriptMedias.async = true;
    const wistiaScriptAssets = document.createElement('script');
    wistiaScriptAssets.src = wistiaScriptAssetsUrl;
    wistiaScriptAssets.async = true;
    document.body.appendChild(wistiaScriptMedias);
    document.body.appendChild(wistiaScriptAssets);
  }, [wistiaScriptMediasUrl, wistiaScriptAssetsUrl]);

  return (
    <div
      className={videoClassName}
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{
        // Embed code from Wistia
        __html: wistiaVideoDiv,
      }}
    />
  );
};
